// extracted by mini-css-extract-plugin
export default {"vCode":"index_vCode_SojNC clearfix","getMsgPinBtn":"index_getMsgPinBtn_jq-0z","disable":"index_disable_mNFlI","red":"index_red_oAUD6","tip":"index_tip_gqCAg"};